import { Type } from '@angular/core';
import { orderHistoryChartsEffects } from './order-history-charts.effects';
import { OrderHistoryFetchEffects } from './order-history-fetch.effect';

export const effects: Type<object>[] = [
    orderHistoryChartsEffects,
    OrderHistoryFetchEffects
];